import axios from 'axios';

import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import merge from 'lodash/merge';
import set from 'lodash/set';

import theme from './theme';
/* istanbul ignore file */

export const BRANDING_PREFIX = '/api/branding';

/** @description prefix all values nested in the `data.key` object */
export function addImageBrandingUrlPrefix(data, key = 'images') {
  /** @description the default will be `data` if no key is present to work with a flat object */
  const urlObject = get(data, key, key ? {} : data);
  Object.keys(urlObject).forEach((urlKey) => {
    const newKey = key ? `${key}.${urlKey}` : urlKey;
    if (isObject(get(data, newKey))) {
      return addImageBrandingUrlPrefix(data, newKey);
    }
    return set(data, newKey, `${BRANDING_PREFIX}/${get(data, newKey)}`);
  });
  return data;
}

export function alignMainColorName(data) {
  const palette = Object.keys(data.palette).reduce((newPalette, paletteAttr) => {
    const variant = data.palette[paletteAttr];
    const paletteAttrObj =
      typeof variant === 'object' ? { ...data.palette[paletteAttr] } : { normal: variant };
    if (paletteAttrObj.main) {
      paletteAttrObj.normal = paletteAttrObj.main;
      delete paletteAttrObj.main;
    }
    return {
      ...newPalette,
      [paletteAttr]: paletteAttrObj
    };
  }, {});
  return { ...data, palette };
}

/**
 * @description This is here while we work on converting the code base over.
 */
function themeConversion(theme) {
  return merge(theme, {
    palette: {
      info: {
        normal: theme.palette.info
      },
      error: {
        normal: theme.palette.error
      },
      warning: {
        normal: theme.palette.warning || theme.palette.error
      }
    },
    buttons: merge(theme.buttons, theme.button)
  });
}

export function fetchTheme() {
  const URL = '/branding/public/brand/activeTheme';
  return axios
    .post(URL)
    .then(({ data }) => data)
    .then(({ data }) => {
      const newData = alignMainColorName(addImageBrandingUrlPrefix(cloneDeep(data)));
      const converted = newData.palette && themeConversion(newData);
      const mergedTheme = theme(converted || newData);
      return mergedTheme;
    })
    .catch(() => theme());
}

export function fetchUserTheme() {
  const URL = '/branding/brand/activeTheme';
  return axios
    .post(URL)
    .then(({ data }) => data)
    .then(({ data }) => {
      const newData = addImageBrandingUrlPrefix(cloneDeep(data));
      const converted = newData.palette && themeConversion(newData);
      const mergedTheme = theme(converted || newData);
      return mergedTheme;
    });
}
export default fetchTheme;
